//= require ./../markdown_editor

window.CompanySettingsVendorRegistrations = {
  intializeMarkdown(selector, name) {
    return MarkdownEditor.initialize(selector, false, true, I18n.t('vendor.registrations.new.registration_description', {company_name: name}));
  }
};